import React, { Component } from "react";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'


class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let product = this.props.product;
    let colorBack = this.props.color;

    return (
      <>
        <div>
          <a href={product.link} target="_blank">
            <div className={product.opacity}>
              <div className="card radius-20">
                <div className={`card-body text-center  ${colorBack}`}>
                  <div className=" box-cont-body">
                  <div className="prod-top">
                    <div className="icon-img d-flex justify-content-center align-items-center">
                      {product ? <img src={product.image} alt={product.title} /> : <Skeleton/>}
                    </div>
                    <h2 className="font-weight-500 prod-head">{product.title || <Skeleton/>  }</h2></div>
                    <p className="paragraph-5">{product.description || product.discription || <Skeleton/>}</p>
                  </div>
                  {/* <div className="powerd-sec d-flex justify-content-between px-3 pt-3">
                    <div className="p-text">powered by</div>
                    <div className="">
                      <img src="https://www.infopercept.com/static/assets/images/email/invinsense-logo.png" alt="Invinsense Logo" />
                    </div>
                  </div> */}
                  <div className="xdr-arrow arr">
                  <img src="images/arrow.png"/>
                </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </>
    );
  }
}

export default Product;
